export const EMAIL_CAMPAIGNS = 'EMAIL_CAMPAIGNS';
export const ZOOM_INTEGRATION = 'ZOOM_INTEGRATION';
export const PROFESSIONAL_SWITCH = 'PROFESSIONAL_SWITCH';
export const ANYWHERE_MEETING = 'ANYWHERE_MEETING';
